import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=646c50fa&scoped=true"
import script from "./Documentacao.vue?vue&type=script&lang=js"
export * from "./Documentacao.vue?vue&type=script&lang=js"
import style0 from "./Documentacao.vue?vue&type=style&index=0&id=646c50fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c50fa",
  null
  
)

export default component.exports